import styled from 'styled-components';

export const Style = styled.div<{ $right: string }>`
  align-items: center;
  justify-content: center;
  height: 22vw;
  min-height: 320px;
  display: flex;
  width: 100%;
  /* border: 1px solid; */
  overflow: hidden;
  .column-1 {
    text-align: center;
    height: 100%;
    width: 40%;
    min-width: 260px;
    position: relative;

    .text-kw {
      position: absolute;
      transform: rotate(-90deg);
      z-index: 3;
      top: 55%;
    }

    .graph {
      width: 100%;
      height: 100%;
      position: relative;
      top: -2%;
      .text {
        position: relative;
        z-index: 3;
        top: 13%;
        left: -6%;
      }
      .box {
        position: absolute;
        width: 136%;
        height: 105%;
        left: -21%;
        top: 2%;
        z-index: 2;
      }
      .chart-container {
        top: 23%;
        /* left: -5%; */
        max-width: 90%;
        z-index: 3;
        position: relative;
      }
    }
  }

  .column-2 {
    height: 100%;
    width: 60%;
    font-weight: bold;
    /* border: 1px solid green; */
    position: relative;
    min-width: 450px;

    .solar {
      width: 146%;
      position: absolute;
      bottom: -60%;
      right: -5%;
      z-index: 1;
    }

    .number {
      position: absolute;
    }

    .box {
      position: absolute;
      width: 51%;
      right: 4%;
    }

    .gauge-box {
      width: 100%;
      height: 100%;
      position: absolute;

      .gauge {
        position: relative;
        /* border: 0.05em solid #222; */
        border-radius: 50%;
        width: 16%;
        height: 34%;
        right: -45%;
      }

      .gauge .needle {
        position: relative;
        margin-bottom: -4%;
        width: 100%;
        height: 100%;
        transform: rotate(calc(270deg * calc(var(--gauge-value, 0deg) / 100) - 47deg));
        transition: all 3s;
      }
      .gauge .needle .needle-head {
        position: relative;
        height: 100%;
        transform: rotate(-47deg);
        top: -9%;
        right: 12%;
      }
    }

    .electricPole {
      width: 90%;
      position: absolute;
      right: -10%;
      bottom: -70%;
    }

    .text {
      position: absolute;
      right: ${({ $right }) => $right};
    }
  }
`;
